<template>
  <div class="privacy-landing">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-background">
        <div class="geometric-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
          <div class="shape shape-4"></div>
        </div>
      </div>
      
      <div class="hero-content">
        <div class="brand-header">
          <div>
            <img src="@/assets/img/logo_lan.png" alt="LAN Logo" class="hero-logo"/>
          </div>
          <div class="brand-text">
            <h1 class="hero-title text-center">Privacy Policy</h1>
            <p class="hero-subtitle text-center">INTRANET</p>
          </div>
        </div>
        
        <div class="hero-description">
          <p class="hero-text">
            Komitmen kami untuk melindungi privasi dan keamanan data dalam penggunaan aplikasi Intranet
          </p>
          <div class="hero-badges">
            <span class="badge">🔒 Secure</span>
            <span class="badge">🛡️ Protected</span>
            <span class="badge">✅ Compliant</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Navigation Menu -->
    <nav class="floating-nav" :class="{ 'sticky': isNavSticky }">
      <div class="nav-container">
        <ul class="nav-menu">
          <li><a href="#policy-overview" @click="scrollToSection('policy-overview')">Overview</a></li>
          <li><a href="#data-collection" @click="scrollToSection('data-collection')">Data Collection</a></li>
          <li><a href="#security" @click="scrollToSection('security')">Security</a></li>
          <li><a href="#biometric" @click="scrollToSection('biometric')">Biometric Data</a></li>
          <li><a href="#contact" @click="scrollToSection('contact')">Contact</a></li>
        </ul>
      </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content">
      <!-- Policy Overview Section -->
      <section id="policy-overview" class="content-section overview-section">
        <div class="section-container">
          <div class="section-header">
            <div class="section-icon">📋</div>
            <h2 class="section-title">Privacy Policy Overview</h2>
            <p class="section-description">Kebijakan dasar kami dalam mengelola informasi Anda</p>
          </div>
          
          <div class="policy-cards">
            <div class="policy-card">
              <h3 class="card-title">Privacy Policy Intranet</h3>
              <p class="card-content">
                Lembaga Administrasi Negara built the Intranet LAN app as a Free app. This SERVICE is provided by Lembaga Administrasi Negara at no cost and is intended for use as is. This page is used to inform applicaton users regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Data Collection Section -->
      <section id="data-collection" class="content-section data-section">
        <div class="section-container">
          <div class="section-header">
            <div class="section-icon">📊</div>
            <h2 class="section-title">Information Collection & Usage</h2>
            <p class="section-description">Bagaimana kami mengumpulkan dan menggunakan data Anda</p>
          </div>
          
          <div class="info-grid">
            <div class="info-card">
              <div class="info-icon">📥</div>
              <h3 class="info-title">Information Collection and Use</h3>
              <p class="info-text">
                If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy. For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.
              </p>
            </div>

            <div class="info-card">
              <div class="info-icon">📝</div>
              <h3 class="info-title">Log Data</h3>
              <p class="info-text">
                We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information on your phone called Log Data. This Log Data may include information such as your device Internet Protocol ("IP") address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
              </p>
            </div>

            <div class="info-card">
              <div class="info-icon">👶</div>
              <h3 class="info-title">Children's Privacy</h3>
              <p class="info-text">
                These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
              </p>
            </div>

            <div class="info-card">
              <div class="info-icon">🔄</div>
              <h3 class="info-title">Changes to This Privacy Policy</h3>
              <p class="info-text">
                We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Security Section -->
      <section id="security" class="content-section security-section">
        <div class="section-container">
          <div class="section-header">
            <div class="section-icon">🔐</div>
            <h2 class="section-title">Security & Protection</h2>
            <p class="section-description">Langkah-langkah keamanan yang kami terapkan</p>
          </div>
          
          <div class="security-card">
            <div class="security-content">
              <h3 class="security-title">Security</h3>
              <p class="security-text">
                We value your trust in providing us your Personal Information, thus we are striving to use any acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
              </p>
            </div>
            <div class="security-visual">
              <div class="security-shield">🛡️</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Biometric Data Section -->
      <section id="biometric" class="content-section biometric-section">
        <div class="section-container">
          <div class="section-header">
            <div class="section-icon">👁️</div>
            <h2 class="section-title">Facial Recognition & Biometric Data</h2>
            <p class="section-description">Kebijakan khusus untuk data biometrik dan pengenalan wajah</p>
          </div>
          
          <div class="biometric-grid">
            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">📸</div>
                <h3 class="bio-title">Data Collection</h3>
              </div>
              <p class="bio-text">
                Our app includes features that use facial recognition technology to enable user registration and attendance verification. 
                When you register for face recognition, the app captures your face image and securely transmits it to our server. The image is processed using OpenCV to extract numerical facial features ("face template"). This template is used solely to identify you during attendance.
              </p>
            </div>

            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">🎯</div>
                <h3 class="bio-title">Purpose of Use</h3>
              </div>
              <p class="bio-text">
                The collected facial data is used exclusively for verifying user identity during attendance and registration. It is not used for analytics, marketing, or any unrelated purposes.
              </p>
            </div>

            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">🔒</div>
                <h3 class="bio-title">Data Storage and Security</h3>
              </div>
              <p class="bio-text">
                All facial templates are stored in encrypted form (AES-256) on secure servers located in our internal server (not clouds server). All communications between the app and our servers are encrypted via HTTPS.
              </p>
            </div>

            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">🚫</div>
                <h3 class="bio-title">No Third-Party Sharing</h3>
              </div>
              <p class="bio-text">
                We do not share, sell, or provide access to any face data to third parties. Only authorized personnel under strict confidentiality obligations may access this data for maintenance and support purposes.
              </p>
            </div>

            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">⏰</div>
                <h3 class="bio-title">Data Retention</h3>
              </div>
              <p class="bio-text">
                Face templates are stored only while your account remains active. If you delete your account or withdraw consent, your face data will be permanently deleted within 7 days. Temporary face images sent during attendance are deleted immediately after verification.
              </p>
            </div>

            <div class="bio-card">
              <div class="bio-header">
                <div class="bio-icon">⚙️</div>
                <h3 class="bio-title">User Control</h3>
              </div>
              <p class="bio-text">
                You can request deletion of your facial data at any time by contacting pusdatin@lan.go.id. Once deleted, your facial template and related data cannot be restored. We comply with applicable data protection and privacy regulations regarding biometric information.
              </p>
            </div>
          </div>

          <div class="consent-banner">
            <div class="consent-icon">✅</div>
            <p class="consent-text">
              Facial data is processed only for the stated purpose and with the user's explicit consent.
            </p>
          </div>
        </div>
      </section>

      <!-- Contact Section -->
      <!-- <section id="contact" class="content-section contact-section">
        <div class="section-container">
          <div class="section-header">
            <div class="section-icon">📞</div>
            <h2 class="section-title">Contact Us</h2>
            <p class="section-description">Hubungi kami untuk pertanyaan atau masukan</p>
          </div>
          
          <div class="contact-card">
            <h3 class="contact-title">Contact Us</h3>
            <p class="contact-text">
              If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
            </p>
          </div>
        </div>
      </section> -->
    </main>

    <!-- Footer -->
    <footer class="footer-section">
      <div class="footer-container">
        <div class="footer-logos">
          <img src="@/assets/img/berakhlak_2.png" alt="Berakhlak" class="footer-logo">
          <img src="@/assets/img/berakhlak_3.png" alt="Berakhlak 3" class="footer-logo small">
          <img src="@/assets/img/logo_bsre_new.png" alt="BSRE" class="footer-logo">
        </div>
        <div class="footer-text">
          <p>&copy; 2025 Lembaga Administrasi Negara. All rights reserved.</p>
        </div>
      </div>
    </footer>

    <!-- Scroll to Top Button -->
    <button 
      class="scroll-top-btn" 
      @click="scrollToTop" 
      :class="{ 'visible': showScrollTop }"
    >
      ↑
    </button>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyIntranetView',
  data() {
    return {
      isNavSticky: false,
      showScrollTop: false
    }
  },
  mounted() {
    this.initScrollListeners()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    initScrollListeners() {
      window.addEventListener('scroll', this.handleScroll)
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      
      // Sticky navigation
      this.isNavSticky = scrollTop > 100
      
      // Show scroll to top button
      this.showScrollTop = scrollTop > 500
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
/* Reset & Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.privacy-landing {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: #2d3748;
  background: #f7fafc;
}

/* Hero Section */
.hero-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.1;
}

.geometric-shapes {
  position: relative;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 150px;
  height: 150px;
  top: 20%;
  right: 15%;
  animation-delay: 2s;
}

.shape-3 {
  width: 100px;
  height: 100px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.shape-4 {
  width: 120px;
  height: 120px;
  bottom: 30%;
  right: 10%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 2rem;
}

.brand-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 3rem;
  flex-wrap: wrap;
}

.hero-logo {
  width: 180px;
  height: auto;
  filter: brightness(0) invert(1);
}

.brand-text {
  text-align: left;
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 0.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: clamp(1rem, 2vw, 1.2rem);
  opacity: 0.9;
  font-weight: 300;
}

.hero-description {
  max-width: 600px;
  margin: 0 auto;
}

.hero-text {
  font-size: clamp(1.1rem, 2.5vw, 1.3rem);
  margin-bottom: 2rem;
  opacity: 0.95;
  line-height: 1.6;
}

.hero-badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.badge {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 0.7rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.badge:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Floating Navigation */
.floating-nav {
  position: fixed;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: all 0.3s ease;
}

.floating-nav.sticky {
  top: 1rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 50px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-container {
  padding: 0.5rem 1rem;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 0.5rem;
}

.nav-menu li a {
  display: block;
  padding: 0.75rem 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  border-radius: 25px;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.9rem;
}

.floating-nav.sticky .nav-menu li a {
  color: #4a5568;
}

.nav-menu li a:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.floating-nav.sticky .nav-menu li a:hover {
  background: #667eea;
  color: white;
}

/* Main Content */
.main-content {
  position: relative;
  z-index: 1;
}

.content-section {
  padding: 5rem 0;
  position: relative;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.section-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
}

.section-description {
  font-size: 1.2rem;
  color: #718096;
  max-width: 600px;
  margin: 0 auto;
}

/* Overview Section */
.overview-section {
  background: white;
}

.policy-cards {
  display: grid;
  gap: 2rem;
}

.policy-card {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border-radius: 20px;
  padding: 3rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.policy-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1.5rem;
}

.card-content {
  color: #4a5568;
  line-height: 1.7;
  text-align: justify;
}

/* Data Collection Section */
.data-section {
  background: linear-gradient(135deg, #f7fafc 0%, #e6fffa 100%);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.info-card {
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.info-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.info-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1rem;
}

.info-text {
  color: #4a5568;
  line-height: 1.6;
  text-align: justify;
}

/* Security Section */
.security-section {
  background: white;
}

.security-card {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 3rem;
  color: white;
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.3);
}

.security-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
}

.security-text {
  font-size: 1.1rem;
  line-height: 1.7;
  opacity: 0.95;
}

.security-visual {
  text-align: center;
}

.security-shield {
  font-size: 8rem;
  opacity: 0.8;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* Biometric Section */
.biometric-section {
  background: linear-gradient(135deg, #fef5e7 0%, #f7fafc 100%);
}

.biometric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.bio-card {
  background: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.bio-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.bio-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.bio-icon {
  font-size: 2rem;
}

.bio-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
}

.bio-text {
  color: #4a5568;
  line-height: 1.6;
  text-align: justify;
}

.consent-banner {
  background: linear-gradient(135deg, #38b2ac 0%, #319795 100%);
  border-radius: 15px;
  padding: 2rem;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.consent-icon {
  font-size: 2rem;
}

.consent-text {
  font-size: 1.1rem;
  font-weight: 500;
}

/* Contact Section */
.contact-section {
  background: white;
}

.contact-card {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.contact-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1.5rem;
}

.contact-text {
  color: #4a5568;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Footer */
.footer-section {
  background: #2d3748;
  color: white;
  padding: 3rem 0;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
}

.footer-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.footer-logo {
  height: 60px;
  width: auto;
  filter: brightness(0) invert(1);
}

.footer-logo.small {
  height: 50px;
}

.footer-text {
  opacity: 0.8;
  font-size: 0.9rem;
}

/* Scroll to Top Button */
.scroll-top-btn {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(100px);
}

.scroll-top-btn.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.scroll-top-btn:hover {
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .brand-header {
    flex-direction: column;
    gap: 1rem;
  }

  .brand-text {
    text-align: center;
  }

  .hero-logo {
    width: 100px;
  }

  .floating-nav {
    top: 1rem;
    left: 1rem;
    right: 1rem;
    transform: none;
  }

  .nav-menu {
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-menu li a {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  .content-section {
    padding: 3rem 0;
  }

  .section-container {
    padding: 0 1rem;
  }

  .info-grid,
  .biometric-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .security-card {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .security-shield {
    font-size: 5rem;
  }

  .scroll-top-btn {
    bottom: 1rem;
    right: 1rem;
    width: 45px;
    height: 45px;
    font-size: 1.3rem;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 0 1rem;
  }

  .hero-badges {
    flex-direction: column;
    align-items: center;
  }

  .badge {
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  .section-header {
    margin-bottom: 2rem;
  }

  .policy-card,
  .contact-card {
    padding: 2rem;
  }

  .security-card {
    padding: 2rem;
  }

  .bio-card,
  .info-card {
    padding: 1.5rem;
  }

  .consent-banner {
    flex-direction: column;
    gap: 0.5rem;
  }

  .footer-logos {
    flex-direction: column;
    gap: 1rem;
  }

  .footer-logo {
    height: 50px;
  }

  .footer-logo.small {
    height: 40px;
  }
}

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Loading animation */
.privacy-landing {
  animation: fadeIn 0.8s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>